const CONTENT = {
  privacy: {
    title: "Privacy Policy",
    overline: "How we handle your data",
    sections: [
      { h: "What we collect", p: "We collect the minimum needed to fulfil your order — your name, email, shipping address, phone, and payment details processed via our payment partner." },
      { h: "How we use it", p: "To ship your order, send transactional emails, respond to your queries, and (only if you opt in) share our fortnightly letter." },
      { h: "Sharing", p: "We never sell your data. We share only with delivery and payment partners strictly needed to complete your order." },
      { h: "Your rights", p: "You may request access, correction, or deletion of your data at any time by writing to Vastrawest@gmail.com." },
    ],
  },
  shipping: {
    title: "Shipping Policy",
    overline: "How we deliver",
    sections: [
      { h: "Free shipping", p: "Complimentary shipping on all orders above ₹999 within India." },
      { h: "Delivery time", p: "Orders placed before 2pm IST ship the same day. Delivery in 3–6 business days across India." },
      { h: "International", p: "We currently ship within India only. International shipping is planned for late 2026." },
    ],
  },
  returns: {
    title: "Returns Policy",
    overline: "How we make it right",
    sections: [
      { h: "7-day window", p: "Return or exchange within 7 days of delivery. Pieces must be unworn, unwashed, with original tags." },
      { h: "Sale items", p: "Sale items are eligible for exchange only, not refund." },
      { h: "How to return", p: "Write to Vastrawest@gmail.com with your order number. We'll arrange a pick-up and process the refund within 5–7 business days." },
      { h: "Refunds", p: "Refunds are credited to your original payment method. Shipping fees on your original order (if any) are non-refundable." },
    ],
  },
  terms: {
    title: "Terms & Conditions",
    overline: "The fine print",
    sections: [
      { h: "Use of site", p: "By using vastrawest.in you agree to these terms. We reserve the right to update them; the current version always lives here." },
      { h: "Product info", p: "We strive for accuracy in colour, sizing, and fabric. Slight variations are inherent to natural fibres and hand-finished garments." },
      { h: "Pricing", p: "All prices are in INR and include GST. We reserve the right to correct pricing errors and cancel affected orders with full refund." },
      { h: "Intellectual property", p: "All content, images, and designs on this site are the property of Vastra West. Please write to us before reproducing." },
    ],
  },
};

const Policy = ({ slug }) => {
  const c = CONTENT[slug];
  return (
    <div data-testid={`policy-${slug}`} className="max-w-3xl mx-auto px-6 py-16 md:py-24">
      <p className="overline text-[color:var(--vw-ink-soft)]">{c.overline}</p>
      <h1 className="font-serif-display text-5xl md:text-7xl italic mt-3">{c.title}</h1>
      <div className="mt-12 space-y-10">
        {c.sections.map((s, i) => (
          <section key={i}>
            <h2 className="font-serif-display text-2xl md:text-3xl italic">{s.h}</h2>
            <p className="mt-3 text-[color:var(--vw-ink-soft)] leading-relaxed">{s.p}</p>
          </section>
        ))}
      </div>
      <p className="mt-16 overline text-[color:var(--vw-ink-soft)]">Last updated · July 2026</p>
    </div>
  );
};

export default Policy;
